import { FormikErrors } from 'formik';
import { useCallback } from 'react';

type FieldGetterProps<FormData> = {
  isProcessing: boolean;
  setFieldValue: <K extends keyof FormData>(
    name: K,
    value: FormData[K]
  ) => void;
  values: FormData;
  formErrors: FormikErrors<FormData>;
};

export function useFieldPropsGetter<FormData>({
  isProcessing,
  setFieldValue,
  values,
  formErrors,
}: FieldGetterProps<FormData>) {
  return useCallback(
    <K extends keyof FormData>(
      name: K,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getVal?: (obj: any) => FormData[K]
    ) => ({
      isDisabled: isProcessing,
      name,
      id: name,
      onChange: (e: React.ChangeEvent<HTMLInputElement>, obj?: unknown) => {
        setFieldValue(
          name,
          getVal
            ? getVal(typeof obj !== 'undefined' ? obj : e)
            : (e.target?.value as any)
        );
      },
      value: values[name],
      ...(formErrors?.[name]
        ? {
            helperText: formErrors?.[name],
            isError: Boolean(formErrors?.[name]),
          }
        : {}),
    }),
    [isProcessing, setFieldValue, values, formErrors]
  );
}
